function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { Image, Button, Menu } from 'semantic-ui-react';
import { formatCurrency } from '../helpers/products';

import { Link } from 'react-router-dom';

var Cart = function (_React$Component) {
  _inherits(Cart, _React$Component);

  function Cart() {
    _classCallCheck(this, Cart);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Cart.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        cartItems = _props.cartItems,
        cartIcon = _props.cartIcon,
        displayForMobile = _props.displayForMobile;


    var total = 0;
    cartItems.forEach(function (obj) {
      if (obj.price === undefined) {
        total += 999;
      } else {
        total += obj.price;
      }
    });

    var headerCartStyle = {
      padding: '0 20px',
      textAlign: 'right',
      background: 'transparent'
    };
    return React.createElement(
      Menu.Item,
      {
        className: 'online-store__cart-header-wrapper ' + (displayForMobile ? 'mobile' : '')
      },
      React.createElement(
        'p',
        { className: 'mobile-cart-header' },
        'Cart Items'
      ),
      React.createElement(
        'div',
        { className: 'online-store__cart-header' },
        React.createElement(Image, {
          src: cartIcon,
          as: Link,
          to: '/checkout',
          className: 'online-store__cart-header-icon am_shopping_cart'
          // $FlowFixMe
          , onClick: this.onNavigate
        }),
        React.createElement(
          'span',
          { className: 'online-store__cart-header-items-count' },
          cartItems ? cartItems.length : 0
        ),
        React.createElement(
          'div',
          { className: 'online-store__cart-header-items' },
          React.createElement(
            'div',
            { className: 'online-store__cart-header-items-inner' },
            cartItems && React.createElement(
              'div',
              { className: 'online-store__cart-header-items-inner-list' },
              cartItems && cartItems.map(function (cartItem, i) {
                return React.createElement(
                  'div',
                  { className: 'row', key: i },
                  React.createElement(
                    'div',
                    { className: 'product-name-col' },
                    React.createElement(
                      Link,
                      { to: cartItem && '/product/' + cartItem.slug },
                      cartItem && cartItem.name
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'price-col' },
                    cartItem && cartItem.price ? formatCurrency(cartItem.price) : '$999.00'
                  ),
                  React.createElement(
                    'div',
                    { className: 'remove-item' },
                    React.createElement(
                      Button,
                      {
                        onClick: function onClick(event) {
                          return (
                            // $FlowFixMe
                            _this2.props.removeFromCart(event, cartItem)
                          );
                        }
                      },
                      React.createElement('i', { className: 'minus circle icon' })
                    )
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'cart-total-price', style: headerCartStyle },
              'TOTAL incl GST',
              ' ',
              React.createElement(
                'span',
                { className: 'bold' },
                formatCurrency(total)
              )
            ),
            cartItems && cartItems.length !== 0 && React.createElement(
              'div',
              { className: 'cart-button-checkout' },
              React.createElement(
                Link,
                { className: 'ui button', to: '/checkout' },
                'Checkout'
              )
            ),
            !cartItems || cartItems.length === 0 && React.createElement(
              'div',
              { className: 'empty-cart' },
              'Cart is Empty'
            )
          )
        )
      )
    );
  };

  return Cart;
}(React.Component);

export default Cart;